var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 844,
    viewBox: "0 0 390 844",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_323)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "#27709A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L310.813 0L0 309.153L0 0Z",
    fill: "url(#paint0_linear_289_323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 844L-2.09402 844L390 454L390 844Z",
    fill: "url(#paint1_linear_289_323)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_289_323",
    x1: 155.406,
    y1: 0,
    x2: 155.406,
    y2: 262.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#32BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3185FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_289_323",
    x1: 329.799,
    y1: 767.047,
    x2: 16.7516,
    y2: 454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0350815,
    stopColor: "#1A4163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3399CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMobile);
export default __webpack_public_path__ + "static/media/LoginMobile.dfdad466bf4e7feccce1fcf5e13e08ef.svg";
export { ForwardRef as ReactComponent };